import { CommonModule, JsonPipe, NgClass, NgIf } from '@angular/common';
import { Component, ElementRef, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from '../../services/global.service';
import { RoleService } from '../../services/role.service';
import { DropdownService } from '../../services/dropdown.service';
import { SelectInputComponent } from "../select-input/select-input.component";
import { UserService } from '../../services/user.service';
import { FormsModule } from '@angular/forms';
import { LoginService } from '../../services/login.service';
import { ExceptionService } from '../../services/exception.service';

@Component({
  selector: 'app-header',
  imports: [NgIf, NgClass, SelectInputComponent, CommonModule, FormsModule, JsonPipe],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
  standalone: true,
})
export class HeaderComponent {

  errorMessage: any = false;
  @Input() label: any = ''
  @Input() hide_school_button: boolean = false;
  @Input() sub_label: any = ''
  @Input() show_back: any = true
  show_user_name: any = true;
  params: any = {}

  check_in_modal = false;

  showBackButton: boolean = false;

  constructor(private router: Router, public gs: GlobalService, public ds: DropdownService, public us: RoleService, private element_ref: ElementRef, public user: UserService, private login: LoginService, public ex: ExceptionService) {
    this.router.events.subscribe(() => {
      this.showBackButton = this.router.url.includes('/form'); // Check if the current route contains "/form"
    });
  }
  async ngOnInit() {
    this.load_notifications();
    const saved = localStorage.getItem("selectedRoleId");
    let role_name = localStorage.getItem("selected_role_name");
    this.gs.users.role = role_name
    this.gs.users.id = saved
    if (saved) {
      this.selectedRoleId = +saved;
    }
    await this.ds?.get_dropdown_list(['role']);
    await this.role_api_call()
  }
  goBack() {
    if (this.showBackButton) { // Only call goBack() if on the form page
      window.history.back();
    }
  }
  selectedRoleId: any = 4;

  async send_role_in_user_list(event: any) {
    console.log(event);

    this.selectedRoleId = event.value.id;  // ⭐ ngModel update

    // API call
    let response = await this.us.get_list({ id: this.selectedRoleId });

    // store role in localStorage
    localStorage.setItem("selectedRoleId", this.selectedRoleId);
    localStorage.setItem("selected_role_name", response.data[0].name);
    let role_name = localStorage.getItem("selected_role_name");
    this.gs.users.role = role_name

    console.log(response, "response");
  }

  async role_api_call() {
    const user_type = this.params?.user_type ?? 'staff';
    const role_data = await this.user.get(this.gs?.user_data?.id);
    this.gs.user_data = role_data.data;
    localStorage.setItem('app_user', JSON.stringify(this.gs.user_data));
    this.gs.user_role_data = role_data.data.Role;
    localStorage.setItem('user_role', JSON.stringify(this.gs.user_role_data));
  }

  back() {
    if (!this.show_back) {
      return;
    }
    window.history.back();
  }

  is_dropdown_visible: boolean = false;
  is_notification_visible: boolean = false;
  notifications: any[] = [];
  unread_count: number = 0;
  notification_filter: 'all' | 'unread' | 'read' = 'all';

  get filtered_notifications(): any[] {
    if (this.notification_filter === 'unread') return this.notifications.filter(n => !n.is_read);
    if (this.notification_filter === 'read') return this.notifications.filter(n => n.is_read);
    return this.notifications;
  }

  @HostListener('document:click', ['$event'])
  async handle_outside_click(event: Event): Promise<void> {
    const clicked_inside = this.element_ref.nativeElement.contains(event.target);
    if (!clicked_inside) {
      this.is_dropdown_visible = false;
      if (this.is_notification_visible) {
        this.is_notification_visible = false;
        await this.mark_all_notifications_read();
      }
    }
  }

  toggle_menu_state(): void {
    this.is_dropdown_visible = !this.is_dropdown_visible;
    this.is_notification_visible = false;
  }

  async load_notifications(): Promise<void> {
    try {
      const response = await this.ex.get_list({ sort_by: 'createdAt', sort_order: 'desc', page_size: 100 });
      this.notifications = response?.data?.rows || [];
      this.unread_count = this.notifications.filter((n: any) => !n.is_read).length;
    } catch { this.unread_count = 0; }
  }

  async toggle_notifications(): Promise<void> {
    this.is_notification_visible = !this.is_notification_visible;
    this.is_dropdown_visible = false;
    if (this.is_notification_visible) {
      await this.load_notifications();
    }
  }

  async mark_all_notifications_read(): Promise<void> {
    if (!this.unread_count) return;
    try {
      await this.ex.mark_exceptions_as_read();
    } catch { }
    this.notifications = this.notifications.map((n: any) => ({ ...n, is_read: true }));
    this.unread_count = 0;
  }

  time_ago(date: string): string {
    if (!date) return '';
    const diff = Math.floor((Date.now() - new Date(date).getTime()) / 1000);
    if (diff < 60) return `${diff}s ago`;
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    return `${Math.floor(diff / 86400)}d ago`;
  }

  async logout() {
    try {
      await this.login.logout({ token: this.gs.user_data?.token });
    } catch { }
    localStorage.clear();
    this.router.navigate(['/sign-in']);
  }
}
